var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"banner",class:{ banner: true, loading: !_vm.bannerUrl},style:(_vm.bannerStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }